import api from './api';
import { sendUploadRequest } from './uploadRequest';

export interface FilePresignedDto {
  file: File;
  destinationUrl: string;
  signedUrl: string;
  expiration: number;
}

export interface UploadFileResult {
  file: File;
  request: XMLHttpRequest;
  isError?: boolean;
  presignedResult?: FilePresignedDto;
}

interface UploadOptions {
  presignBody: any;
  /** Override the ceiling below. Milliseconds; 0 disables the timeout. */
  timeoutMs?: number;
}

export class UploadFile {
  loading = false;
  progress = 0;

  constructor(private readonly presignEndPoint: string) {}

  async presignUrl(
    file: File,
    options?: UploadOptions
  ): Promise<FilePresignedDto> {
    const { presignBody = {} } = options || {};
    this.loading = true;
    const result = await api.post(this.presignEndPoint, {
      mimeType: file.type,
      ...presignBody
    }).response;
    this.loading = false;
    return result.json();
  }

  async upload(file: File, options?: UploadOptions) {
    const presignedResult = await this.presignUrl(file, options);
    if (!presignedResult) {
      console.error('Presign failed');
      return;
    }
    const request = new XMLHttpRequest();
    const uploadingFile: UploadFileResult = {
      file,
      request,
      presignedResult
    };
    return new Promise<UploadFileResult>((resolve, reject) => {
      sendUploadRequest({
        request,
        file,
        signedUrl: presignedResult.signedUrl,
        endpoint: this.presignEndPoint,
        timeoutMs: options?.timeoutMs,
        onProgress: fraction => (this.progress = fraction),
        onSuccess: () => {
          this.progress = 1;
          resolve(uploadingFile);
        },
        onFailure: reason => {
          this.progress = 0;
          uploadingFile.isError = true;
          reject(new Error(`Upload of ${file.name} failed: ${reason}`));
        }
      });
    });
  }
}
